module.exports = __webpack_public_path__ + "static/media/GEMS.cb042b36.jpg";